var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConvertColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.057,
    height: 24.276,
    viewBox: "0 0 24.057 24.276",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .convertColored{fill:#8c8d99}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18282",
    "data-name": "Group 18282",
    transform: "translate(-294.439 -648.011)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_281",
    "data-name": "Ellipse 281",
    cx: 2.732,
    cy: 2.732,
    r: 2.732,
    transform: "translate(303.736 658.011)",
    style: {
      fill: "#1bc47d"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18215",
    "data-name": "Group 18215",
    transform: "translate(.237 .456)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8487",
    "data-name": "Path 8487",
    className: "convertColored",
    d: "M316.181 658.89a.819.819 0 0 0 .922.751h.214v-.01a.794.794 0 0 0 .912-.7 12.006 12.006 0 0 0-20.443-7.894.906.906 0 0 0-.1.11l-1.717-1.739a.686.686 0 0 0-1.172.416l-.521 5.339a.687.687 0 0 0 .742.75l5.345-.451a.687.687 0 0 0 .431-1.166l-1.676-1.7a1.085 1.085 0 0 0 .113-.1 9.951 9.951 0 0 1 16.934 6.4z",
    transform: "translate(.028)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8488",
    "data-name": "Path 8488",
    className: "convertColored",
    d: "M296.247 656.772a.821.821 0 0 0-.876-.8l-.214-.008v.01a.8.8 0 0 0-.952.643 12.005 12.005 0 0 0 19.945 9.078 1.036 1.036 0 0 0 .1-.1l1.611 1.835a.685.685 0 0 0 1.194-.346l.832-5.3a.686.686 0 0 0-.7-.793l-5.361.137a.685.685 0 0 0-.5 1.139l1.573 1.794a.918.918 0 0 0-.12.091 9.95 9.95 0 0 1-16.529-7.377z",
    transform: "translate(-.001 3.14)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertColored);
export default __webpack_public_path__ + "static/media/convert-colored.314cb759bbcae445c851e2034b112ce4.svg";
export { ForwardRef as ReactComponent };